import React from 'react';

import { CoachSet } from '../../pages/CoachTaskAdmin/utils';

const initialValues = {
  isReady: false,
  // Which coaches are listed: CoachSet.MINE (the default), CoachSet.ALL or a CAM's user id.
  coachSet: CoachSet.MINE,
  setCoachSet: () => {},
  // The CAMs to pick from, as [{ id, name }] sorted by name, from current CAM assignments.
  camOptions: [],
  // Coaches the logged-in AC/CAM manages (the default view).
  managedCoachIds: [],
  // The set currently shown, per coachSet.
  activeCoachIds: [],
  // { coachId: coachName } from coach docs (CoachesListContext).
  coachNameById: {},
  // { coachId: CoachTask[] } and { coachId: { open, completed, overdue } }, derived
  // reactively from live coachActivity collections.
  tasksByCoach: {},
  countsByCoach: {},
};

const CoachTaskAdminContext = React.createContext(initialValues);

export default CoachTaskAdminContext;
export { initialValues };
